import { render } from "./BaseControl.vue?vue&type=template&id=1d1ffc42&ts=true"
import script from "./BaseControl.vue?vue&type=script&lang=ts"
export * from "./BaseControl.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__